import { PageHeader } from "../../components/PageHeader";
import { CashflowCalendarPanel } from "./CashflowCalendarPanel";
import { TreasuryForecastPanel } from "./TreasuryForecastPanel";

export function TesourariaView() {
  return (
    <div className="h-full overflow-auto bg-background">
      <PageHeader
        title="Tesouraria"
        subtitle="Visão global de tesouraria: recebimentos e pagamentos previstos"
      />

      <div className="px-4 md:px-6 py-6 md:py-8 space-y-8">
        <TreasuryForecastPanel />
        <CashflowCalendarPanel />
      </div>
    </div>
  );
}
